// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2FG20","title":"Images45_title__quB-a","images":"Images45_images__3B1WN"};